import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ddmmyyyy' // <-- Must match usage in template
    ,
    standalone: false
})
export class DdmmyyyyPipe implements PipeTransform {
  transform(value: Date | string): string {
    const date = value instanceof Date ? value : new Date(value);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }
}
